import React from 'react';

type ViewOnlyNoteType = {
  note: string;
};

export const ViewOnlyNote: React.FC<ViewOnlyNoteType> = ({ note }) =>
  note && (
    <div className="margin-bottom margin-top">
      <span className="small text-muted">{note}</span>
    </div>
  );
